import { Flame, Trophy, Rocket } from "lucide-react";

const ICON = { hot_streak: Flame, best_week: Trophy, longshot: Rocket };
const STYLE = {
  hot_streak: "bg-orange-500/15 text-orange-300 border-orange-500/40",
  best_week: "bg-emerald-500/15 text-emerald-300 border-emerald-500/40",
  longshot: "bg-fuchsia-500/15 text-fuchsia-300 border-fuchsia-500/40",
};

export function Badges({ badges = [], size = "sm" }) {
  if (!badges.length) return null;
  const big = size === "lg";
  return (
    <span className="flex flex-wrap gap-1.5" data-testid="badges">
      {badges.map((b) => {
        const Icon = ICON[b.key] || Trophy;
        return (
          <span key={b.key} data-testid={`badge-${b.key}`} className={`inline-flex items-center gap-1 rounded-full border font-bold uppercase tracking-wider ${STYLE[b.key]} ${big ? "px-3 py-1 text-xs" : "px-2 py-0.5 text-[10px]"}`}>
            <Icon size={big ? 13 : 10} /> {b.label}
          </span>
        );
      })}
    </span>
  );
}
